import React from "react";
import "./Product_Banner.css"
import { useSelector } from "react-redux";

function Product_Banner() {
  
  const product = useSelector((state) => state.product?.product?.banner1);

  return (
    <section className="banner">
      <div className="container-fluid p-0">
        <div className="banner_wrapper">
          {/* <img
            src="/assets/images/home/banner/b2.png"
            alt="banner"
            className="banner_img"
          /> */}
          <img src={process.env.REACT_APP_IMG_URL + product} alt="banner"  className="banner_img" />
        </div>
      </div>
    </section>
  );
}

export default Product_Banner;
